/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LaborCostLogDto } from '../../models/labor-cost-log-dto';

export interface GetLaborCostLog$Params {
  id: string;
}

export function getLaborCostLog(http: HttpClient, rootUrl: string, params: GetLaborCostLog$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborCostLogDto>> {
  const rb = new RequestBuilder(rootUrl, getLaborCostLog.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LaborCostLogDto>;
    })
  );
}

getLaborCostLog.PATH = '/v0/laborCostLogs/{id}';
